import QueryGetRoles from '../GraphQL/Query-GetRoles';

const ROLES_SET_ACTION = 'ROLES_SET';
const ROLES_CLEAR_ACTION = 'ROLES_CLEAR';

const ROLES_REFETCH_THRESHOLD_MS = 5000;

export function rolesDefaultState() {
  return {
    list: [],
    keys: [],
    lastFetchedAt: null,
  };
}

export function shouldRefetchRoles(state) {
  if (!state?.lastFetchedAt) return true;
  return Date.now() - state.lastFetchedAt > ROLES_REFETCH_THRESHOLD_MS;
}

export async function getRoles(dispatch, client) {
  const { data } = await client.query({
    query: QueryGetRoles,
    fetchPolicy: 'network-only',
    variables: {},
  });

  dispatch({
    type: ROLES_SET_ACTION,
    payload: { roles: data.getRoles, lastFetchedAt: Date.now() },
  });
}

export function clearRoles(dispatch) {
  dispatch({
    type: ROLES_CLEAR_ACTION,
  });
}

export default (state = rolesDefaultState(), action) => {
  switch (action.type) {
    case ROLES_SET_ACTION: {
      const { payload } = action;
      const roles = payload.roles || payload;

      state.list = roles.map(r => ({
        name: r.name,
        displayName: r.displayName,
        corporateStructure: r.corporateStructure,
        assignable: r.assignable,
      }));
      state.keys = roles.map(r => r.name);
      state.lastFetchedAt = payload.lastFetchedAt ?? null;

      return { ...state };
    }

    case ROLES_CLEAR_ACTION:
      return rolesDefaultState();

    default:
      return state;
  }
};
